import { Component, Injector } from "@angular/core";
import { DisplayModeParams, ChartDisplayMode } from '../../enums/ChartDisplayMode.list';
import { AppComponentBase } from "../../services/AppComponentBase";

@Component({
    selector: "layoutmode-tabs",
    template: require('./layoutDisplayModeTabs.component.html'),
    styles: [
        require('../quotePanelTabs/quotePanelTabs.component.css')
    ]
})

export class layoutDisplayModeTabs extends AppComponentBase {
    
    tabs: object= DisplayModeParams();
    

    constructor(injector: Injector){
        super(injector)        
    }

    get activeTab(): ChartDisplayMode {
        return this.workspace.chartDisplayMode;
    }

    set activeTab(tabId: ChartDisplayMode) {        
        this.workspace.chartDisplayMode = tabId;     
        
    }

}